import { getPeriodByKey, PM_PERIODS } from './PMConstants';
import { PERIOD } from './CommonConstants';
import variables from '../../styles/colors.module.scss';

const { graydark: grayDark, graylight: grayLight, redinterp: redInterp, green } = variables;

export const INDEX = {
    ROW_START_INDEX: 1,
    LAST_SCORES_START_INDEX: 3,
    LAST_SCORES_END_INDEX: 5,
    COUNT_OF_COLUMNS: 6,
};

export const MAX_RANGE = 100;

export const GROWTH_RATE = {
    WELL_BELOW_AVERAGE: 'Well Below Average',
    BELOW_AVERAGE: 'Below Average',
    AVERAGE: 'Average',
    ABOVE_AVERAGE: 'Above Average',
    WELL_ABOVE_AVERAGE: 'Well Above Average',
};

export const PERIODS_FOR_ZOG = [
    getPeriodByKey(PM_PERIODS, PERIOD.BOY_MOY),
    getPeriodByKey(PM_PERIODS, PERIOD.MOY_EOY),
];

export const ZOG_SECTIONS = [
    GROWTH_RATE.AVERAGE,
    GROWTH_RATE.ABOVE_AVERAGE,
    GROWTH_RATE.WELL_ABOVE_AVERAGE,
];

export const STYLE = {
    CELL_CONTAINER_CSS_OBJECT: {
        border: `solid ${grayDark}`,
        borderWidth: '1px 1px 0 0',
    },
    SUCCESS_VALIDATION_OBJECT: { color: green, text: 'Saved', type: 'S' },
    ERROR_VALIDATION_OBJECT: { color: redInterp, type: 'E' },
    RUNNING_GIRL_CONTAINER_CSS_STRING: 'width: 3%; height: 15%; bottom: 80%; left: 15.3%;',
    PROGRESS_BAR_CONTAINER_CSS_STRING: 'height: 60%',
    COLOR: {
        COMPOSITE_BG: grayLight,
        INPUT_BORDER: grayDark,
    },
};

export const VALIDATION = {
    VALUE: {
        DOT: '.',
        EMPTY_RANGE_MIN: 1,
        READING_ACCURACY_MAX: 100, // measures: ORF_ACC, FLO_PREC
        RANGE_MAX: 999,
        EMPTY: '',
    },
    MESSAGE: {
        ENTER_POSITIVE_INTEGER: 'Enter positive integer',
        ENTER_POSITIVE_INTEGER_OR_DECIMAL_ONLY: 'Enter positive integer or decimal 0.5 only',
        GOALS_CAN_NOT_BE_LESS_AVERAGE: 'Goals cannot be less than average growth',
        VALUE_MUST_BE_LESS_OR_EQUAL_100: 'Value must be less than or equal to 100%',
        VALUE_MUST_BE_LESS_999: 'Value must be less than 999',
    },
    BASIC_COMPREHENSION_REG_EXP: /^\s*(?=.*[1-9])\d*(?:\.[5])?\s*$/, // measures: CLPL, MAZE
};
